export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function camelCaseToWords(str: string) {
  return str.replace(/([A-Z]+)/g, ' $1').replace(/([A-Z][a-z])/g, ' $1');
}

export function replaceHTMLSpecialChars(str: string): string {
  return str.replace(/&#039;|&#39;/g, "'")
      .replace(/&#34;/g, '"')
      .replace(/&amp;/g, '&');
}

export function truncateString(str: string, requiredLength: number) {
  return str.length > requiredLength ? str.substring(0, requiredLength - 3) + '...' : str;
}

export function capitalizeAllWordsInString(str: string) {
  return str
    .split(' ')
    .map((word) => capitalizeFirstLetter(word))
    .join(' ');
}

export const getMaskedString = ({
  value,
  visibleChars = 4,
  maskWithChar = '*',
}: {
  value: string | number;
  visibleChars?: number;
  maskWithChar?: string;
}) => {
  if (value === undefined || value === null) {
    return '';
  }
  const stringValue = String(value);
  if (!stringValue) {
    return '';
  }
  if (stringValue.length <= visibleChars) {
    return stringValue;
  }
  const maskedLength = stringValue.length - visibleChars;
  const maskedString = maskWithChar.repeat(maskedLength);
  const visibleString = stringValue.slice(-visibleChars);
  return maskedString + visibleString;
};
